<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="normal"
      no-padding
      :content-style="{padding: '18px 20px 30px'}"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>{{ title }}</span>
    </template>
    <template #content>
        <div class="warning">{{ warning }}</div>
        <div class="details">
          <div class="details-cell" v-for="(item, index) in details" :key="index">
            {{ item.msg && (index + 1 + ".") }}
            {{ item.msg || item }}
            <i v-if="item.anchorIndex" class="el-icon-edit" @click="edit(item.anchorIndex)"></i>
          </div>
        </div>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "@/minxins";

  export default {
    name: "ad-sb-popup-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      title: {
        default: '标题'
      },
      warning: {
        default: ''
      },
      details: {
        default: () => []
      },
      confirmText: {
        type: String,
        default: '确定'
      },
      cancelText: {
        type: String,
        default: '取消'
      },
    },
    data() {
      return {}
    },
    methods: {
      edit(index) {
        this.$gjDestroy();
        this.$emit('edit', index);
      },
      confirm() {
        this.$gjDestroy();
        // this.$emit('confirm');
      }
    }
  }
</script>

<style scoped lang="scss">
.warning, .details {
    font-size: 12px;
    color: #333;
}
.warning {
    color: #f00;
    padding-bottom: 9px;
}
.details-cell {
  padding: 0 0 6px;
  .el-icon-edit {
    display: none;
  }
  &:hover {
    .el-icon-edit {
      display: inline-block;
      color: #1F6EEF;
      cursor: pointer;
    }
  }
}
</style>
